import React from 'react'
import session from '../session'
import Profile from './Profile'

export default () => <Profile identifier={session.email()} />
